import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@shadcn-in-nx/ui/badge";

const STATUS_VARIANTS = {
    completed: "default",
    in_progress: "secondary",
    failed: "destructive",
    pending: "outline",
};

const STATUS_KEYS = {
    completed: "statusCompleted",
    in_progress: "statusInProgress",
    failed: "statusFailed",
    pending: "statusPending",
};

export default function BackfillStatusBadge({ status }) {
    const { t } = useTranslation();
    const variant = STATUS_VARIANTS[status] || "outline";
    const label = t(`adminDataMigration.${STATUS_KEYS[status] || "statusPending"}`);

    return <Badge variant={variant}>{label}</Badge>;
}
